<!--
 * @Description:服务项目配置服务套餐
 * @Author:sunhuihong
 * @Date: 2022-05-26 08:28:58
 * @LastEditTime: 2024-03-25 10:39:13
-->
<template>
  <div class="view-hsvc-cfg-service-package">
    <el-form class="form" label-width="75px" ref="hsvcCfgPkgForm" :model="hsvcCfgPkgForm" :rules="rules" 
      label-position="left">
      <el-row style="margin: 30px 25px; padding-top: 20px;" :gutter="0" type="flex" justify="space-between">
        <el-col :span="17" >
          <el-row style="width: 100%;">
            <el-button size="medium" :disabled="readonly" type="text" icon="el-icon-circle-plus-outline" 
              style="float: right; color: #3A7FF3;" @click="handleAddSetMeal">
              新增新套餐
            </el-button>          
          </el-row>
          <div style="border: 1px solid #ccc; padding: 15px 30px 30px 10px; margin: 10px 0;" 
            v-for="(item,index) in hsvcCfgPkgForm.servicePkgCfgList" :key="index">
            <el-row style="line-height: 30px;">
              <el-col :span="12">
                <span class="title-tag"></span>
                <span class="title-name">套餐{{index+1}}</span>
              </el-col>
              <el-col :span="12" style="text-align: right;" 
                v-if="hsvcCfgPkgForm.servicePkgCfgList && hsvcCfgPkgForm.servicePkgCfgList.length > 1">
                <el-button style="color: #F33A3A; padding: 0;" type="text"  :disabled="readonly" 
                  icon="el-icon-delete" @click.native="deleteHserviceCfgPackage(item, index)">
                  删除套餐
                </el-button>
              </el-col>
            </el-row>
            <el-row style="margin-left: 17px;">
              <el-col :span="16" >
                <el-form-item label="服务套餐:" label-width="82px" :prop="'servicePkgCfgList.'+index+'.name'" 
                  :rules="[
                    { required: true, message: '请输入套餐名称', trigger: 'blur' },
                    { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
                  ]">
                  <el-input v-model.trim="item.name"  placeholder="请输入套餐名称"  size="small"  :disabled="readonly" 
                    :readonly="readonly">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-left: 17px;" type="flex"  justify="space-between" >
              <el-col :span="8">
                <el-form-item label="服务现价:" label-width="82px" :prop="`servicePkgCfgList.${index}.curPriceYuan`" 
                  :rules="rules.curPriceYuan" >
                  <el-input  v-model="item.curPriceYuan" placeholder="服务现价"  size="small"  :disabled="readonly" >
                    <template slot="append" style="padding: 0 10px;">元/次</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8" style="margin: 0 20px;">
                <el-form-item label="服务原价:" label-width="82px" :prop="`servicePkgCfgList.${index}.originalPriceYuan`" 
                  :rules="rules.originalPriceYuan"  >
                  <el-input  v-model="item.originalPriceYuan" placeholder="服务原价" size="small" :disabled="readonly" 
                    :readonly="readonly">
                    <template slot="append" >元/次</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="服务时长:" label-width="82px" :prop="`servicePkgCfgList.${index}.serviceDuration`" 
                  :rules="rules.serviceDuration"  >
                  <el-input  v-model="item.serviceDuration" placeholder="请输入"  size="small"  :disabled="readonly" 
                    :readonly="readonly">
                    <template slot="append" >小时</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="6" >
          <div style="height: 1100px; overflow-y: scroll">
            <img style="width: 100%;" src="@/assets/hsvccfg/app.png"  alt="">
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div class="bk-wizard-bottons" style="padding-right: 25px;">
      <wizard-buttons :mode="mode" :status="btnStatus" @btnpressed="handleBtnSelection" />
    </div>
  </div>
</template>
<script>
import hsvcCfgDetailStore from './HsvcCfgDetailStore.js';

let HsvcCfgServicePackagePanel=  {
  name: 'HsvcCfgServicePackagePanel',
  hsvcCfgDetailStore,
  
  data() {
    let validatePrice= (_rule, value, callback) => {
      let pattern = /^\d+(\.\d{1,2})?$/;
      if (!pattern.test(value)) {
        return callback(new Error('小数点后最多只能输入两位'))
      } else {
        callback()
      }
    };

    let serviceDuration= (_rule, value, callback) => {
      let pattern = /^\d*$/;
      if (!pattern.test(value)) {
        return callback(new Error('只能输入整数'))
      } else if (value == 0) {
        return callback(new Error('服务时长需大于0'))
      } else {
        callback()
      }
    };

    return {
      clickIndex: '',
      rules: {
        curPriceYuan: [
          { required: true, message: '请输入套餐现价', trigger: 'blur' },
          { validator: validatePrice, trigger: 'change' },
        ],
        originalPriceYuan: [
          { required: true, message: '请输入套餐原价', trigger: 'blur' },
          { validator: validatePrice, trigger: 'change' },
        ],

        serviceDuration : [
          { required: true, message: '请输入服务时长', trigger: 'blur' },
          { validator: serviceDuration, trigger: 'change' },
        ],
      },
      showAddPackagePanelDialog: false,
      btnStatus: {'prev': true, 'next': false, 'submit': true}, 
      hsvcCfgPkgForm: {
        servicePkgCfgList : hsvcCfgDetailStore.state.servicePkgCfgList
      },
    }
  },

  computed: {
    mode() {
      return hsvcCfgDetailStore.state.mode;
    },

    servicePkgData() {
      return hsvcCfgDetailStore.state.servicePkgCfgList;
    },

    readonly() {
      return hsvcCfgDetailStore.state.mode == 'details';
    }  
  },

  methods: {
    //新增套餐
    handleAddSetMeal() {
      hsvcCfgDetailStore.state.servicePkgCfgList.push({
        name: '',
        curPriceYuan: '',
        originalPriceYuan: '',
        serviceDuration: '',
        includeAttendantPrice: 0,
        highPriceYuan: '0.0',
        middlePriceYuan: '0.0',
        primaryPriceYuan: '0.0',
     })
    },

    //删除服务套餐
    deleteHserviceCfgPackage(_item, index) {
      let strMessage = '套餐' + (index + 1) + '将被删除，是否继续删除？'
      this.$confirm(strMessage, '提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        hsvcCfgDetailStore.state.servicePkgCfgList.splice(index, 1)
      })
    },

    handleBtnSelection(operate) {
      if (this.mode == 'details' || operate != 'next'&& operate != 'add' && operate != 'edit')  {
        this.$emit("panel-operate", operate);
        return true;
      }
      this.$refs.hsvcCfgPkgForm.validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.$emit("panel-operate", operate);
          return true;
        }
      });
    },
  },

  //销毁的时候同步数据
  destroyed() {
    hsvcCfgDetailStore.commit('changeServicePkgCfgList', this.servicePkgData);
  },
}
export default HsvcCfgServicePackagePanel

</script>
<style >
.view-hsvc-cfg-service-package .el-input-group__append {
  padding: 0 10px;
}

.view-hsvc-cfg-service-package .el-input__inner {
  padding: 0 0 0 10px;
}

.view-hsvc-cfg-service-package .el-form-item__content .el-input-group {
  vertical-align: middle;
}
</style>
<style scoped>
.delete-style {
  color:#e04a52;
  width:20px;
  height:20px;
  line-height: 50px;
  margin: 0 10px;
}

.add-style {
  background-color: #EFF5FA;
  margin: 5px 0 10px 0;
  text-align: center;
  line-height: 24px;
}

.title-tag {
  display: inline-block;
  width: 4px;
  height: 16px;
  margin-bottom: 4px;
  margin-left: 10px;
  background: #2A97FF;
  border-radius: 2px;
  margin-right: 9px;
  vertical-align: middle;
} 

.title-name {
  width: 37px;
  height: 14px;
  font-size: 14px;
  font-weight: 400;
  color: #657180;
  line-height: 30px;
}

.view-add-attendant-price {
  background: #EFF5FA;
  padding: 18px 16px 20px 21px;
  margin-left: 12px;
  position: relative;
}

.view-add-attendant-price-title {
  display: block;
  margin-bottom: 25px;
  font-size: 14px;
  font-weight: 400;
  color: #657180;
}

.delete-attendant {
  width: 30px;
  position: absolute;
  text-align: center;
  top: 30px;
  right: 0;
  margin-right: 18px;
  cursor: pointer;
}

.form {
  margin-bottom: 60px;
}
</style>





// WEBPACK FOOTER //
// src/components/hsvccfg/components/hsvcCfgDetails/HsvcCfgServicePackagePanel.vue